<app-header
    [title]="'my_claims.claim_detail' | translate"
    [backLinkText]="'my_claims.go_to_my_claims' | translate"
    [backLinkGtmLabel]="'claim-funnel_link_back-to--claims'"
    (onBackLinkClick)="goBack()"
/>
<div class="content">
<div class="grid grid-cols-1 md:grid-cols-12 gap-4" *ngIf="claim">
    <!-- 🧾 Contenido principal -->
  <div class="order-2 md:order-1 md:col-span-8 w-full">
      <app-claim-summary [claim]="this.claim" (onTabSwitch)="currentTab = $event"/>
  </div>

    <!-- 📌 Sidebar New Claim -->
    <div class="order-1 md:order-2 md:col-span-4">
      <app-score-box [claim]="this.claim" [currentTab]="currentTab" (onGoToComments)="switchToComments()" />
    </div>
  </div>
</div>

